import type { SelectedAccommodationReservation } from "../../reservation-form/reservation-calendar/reservation-calendar";

type DirectConfirmUrlInput = {
  /** 発行する StayTicketTemplate の lookupKey（`ticket` パラメータ） */
  stayTicketTemplateLookupKey: string;
  roomTypeId: string;
  /** `accommodationFacilities` は空なら `accommodationFacility` パラメータを付けない */
  selection: SelectedAccommodationReservation;
  /** false なら `ev` パラメータを付けない */
  evChargerAvailable: boolean;
  /** エンコード前のパス */
  returnTo: string;
};

/**
 * 選択日程分の StayTicket を発行して予約確定ページへ直行する /ticket-issue の URL を組み立てる。
 */
export function buildDirectConfirmUrl({
  stayTicketTemplateLookupKey,
  roomTypeId,
  selection,
  evChargerAvailable,
  returnTo,
}: DirectConfirmUrlInput): string {
  const params = new URLSearchParams();
  params.set("ticket", stayTicketTemplateLookupKey);
  params.set("directConfirm", "true");
  params.set("roomTypeId", roomTypeId);
  params.set("accommodationId", selection.accommodationId);
  params.set("ci", selection.firstNight.toString());
  // co はチェックアウト日のため、最終泊の翌日を渡す。
  params.set("co", selection.lastNight.add({ days: 1 }).toString());
  // 確定ページで部屋タイプが取得できず室を選び直せない場合のフォールバックとして引き継ぐ。
  for (const facility of selection.accommodationFacilities) {
    params.append("accommodationFacility", facility);
  }
  if (evChargerAvailable) {
    params.set("ev", "true");
  }
  params.set("returnTo", returnTo);
  return `/ticket-issue?${params.toString()}`;
}
